import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './footer.css'

const Footer = (props) => {
  return (
    <div id={props.footerId} className="footer-container1">
      <div className="footer-container2">
        <Link to="/impressum" className="footer-impressum">
          {props.textImpressum ?? (
            <Fragment>
              <span className="footer-text2">Impressum</span>
            </Fragment>
          )}
        </Link>
        <Link to="/privacy-policy" className="footer-privacy-policy">
          {props.textPrivacyPolicy ?? (
            <Fragment>
              <span className="footer-text1">Privacy Policy</span>
            </Fragment>
          )}
        </Link>
        <a
          href="mailto:contact@stefanlacher.com?subject=Message from stefanlacher.com"
          className="footer-contact"
        >
          {props.textContact ?? (
            <Fragment>
              <span className="footer-text6">Contact</span>
            </Fragment>
          )}
        </a>
      </div>
      <div className="footer-container3">
        <span className="footer-jahr">
          {props.textYear ?? (
            <Fragment>
              <span className="footer-text4">© 2025</span>
            </Fragment>
          )}
        </span>
        <span className="footer-made">
          {props.textMade ?? (
            <Fragment>
              <span className="footer-text3">Made with</span>
            </Fragment>
          )}
        </span>
        <img
          alt={props.heartImageAlt}
          src={props.heartImageSrc}
          className="footer-image"
        />
        <span className="footer-name">
          {props.textName ?? (
            <Fragment>
              <span className="footer-text5">Stefan Lacher</span>
            </Fragment>
          )}
        </span>
      </div>
    </div>
  )
}

Footer.defaultProps = {
  textPrivacyPolicy: undefined,
  heartImageAlt: 'image',
  textImpressum: undefined,
  textMade: undefined,
  footerId: 'FooterId',
  textYear: undefined,
  textName: undefined,
  textContact: undefined,
  heartImageSrc: '/love-200h.webp',
}

Footer.propTypes = {
  textPrivacyPolicy: PropTypes.element,
  heartImageAlt: PropTypes.string,
  textImpressum: PropTypes.element,
  textMade: PropTypes.element,
  footerId: PropTypes.string,
  textYear: PropTypes.element,
  textName: PropTypes.element,
  textContact: PropTypes.element,
  heartImageSrc: PropTypes.string,
}

export default Footer
